import { iframeResizerContentWindow } from "iframe-resizer";

const pageContainer = document.querySelector(".microsite-wrapper");
const notifyParentResize = () => {
  if (window.parentIFrame) window.parentIFrame.size(pageContainer.scrollHeight);
};
window.iFrameResizer = { onReady: notifyParentResize };
new ResizeObserver(notifyParentResize).observe(pageContainer);
iframeResizerContentWindow;
